import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: {
    overflowY: 'auto'
  },
  paper: {
    overflow: 'auto',
    margin: 'auto',
    width: '40%',
    padding: 24,
    marginTop: '15vh',
    marginBottom: '8vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh',
      textAlign: 'center'
    }
  },
  icon: { display: 'flex', alignItems: 'center', width: '32%' },
  buttonContianer: {
    marginTop: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  dropZone: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  }
}))
export default useStyles
